import React from 'react'

const NotAvailable = () => {
  return (
    <h1 className='not-available'>
      No Movies available for selected genres
    </h1>
  )
}

export default NotAvailable